// ============================================================
// Preferência de coleta (opt-out) — design.md D19
//
// Chave própria do pacote, lida de forma síncrona ANTES do import
// dinâmico do SDK: é o que garante que uma recusa vale já na primeira
// carga da sessão seguinte — sem ela, o $pageview inicial escaparia
// enquanto o SDK sobe. Quando o SDK está carregado, a preferência é
// sincronizada também com o mecanismo de consentimento dele
// (opt_out_capturing / opt_in_capturing).
//
// O escopo é a origem (localStorage), o que no cardápio significa por
// subdomínio de tenant — consequência deliberada de D4: recusar na
// Loja A não recusa na Loja B, porque são tratamentos distintos.
// ============================================================

const OPT_OUT_STORAGE_KEY = 'vapt_analytics_opt_out';

export function readOptOutPreference(): boolean {
  try {
    return localStorage.getItem(OPT_OUT_STORAGE_KEY) === '1';
  } catch {
    // Storage indisponível (modo privado restrito): sem persistência o SDK
    // também não guarda identidade, então a coleta segue anônima e efêmera.
    return false;
  }
}

export function writeOptOutPreference(optedOut: boolean): boolean {
  try {
    if (optedOut) {
      localStorage.setItem(OPT_OUT_STORAGE_KEY, '1');
    } else {
      localStorage.removeItem(OPT_OUT_STORAGE_KEY);
    }
    return true;
  } catch {
    return false;
  }
}
